
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport07SkuWhsDialog extends Serenity.EntityDialog<IcReport07SkuWhsRow, any> {
        protected getFormKey() { return IcReport07SkuWhsForm.formKey; }
        protected getIdProperty() { return IcReport07SkuWhsRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport07SkuWhsRow.localTextPrefix; }
        protected getNameProperty() { return IcReport07SkuWhsRow.nameProperty; }
        protected getService() { return IcReport07SkuWhsService.baseUrl; }
        protected getDeletePermission() { return IcReport07SkuWhsRow.deletePermission; }
        protected getInsertPermission() { return IcReport07SkuWhsRow.insertPermission; }
        protected getUpdatePermission() { return IcReport07SkuWhsRow.updatePermission; }

        protected form = new IcReport07SkuWhsForm(this.idPrefix);

    }
}